var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({ref:"el",staticClass:"omapi-button omapi-wizard-forward omapi-button__green",attrs:{"type":"submit","disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }